import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-styled-checkbox',
  standalone: true,
  imports: [MatCheckboxModule, NgIf, NgTemplateOutlet],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StyledCheckboxComponent),
      multi: true
    }
  ],
  templateUrl: './styled-checkbox.component.html',
  styleUrls: ['./styled-checkbox.component.scss']
})
export class StyledCheckboxComponent implements ControlValueAccessor {
  @Input() checked = false;
  @Input() wrapWithLabel = true;
  @Output() checkedChange = new EventEmitter<boolean>();
  
  disabled = false;
  onChange = (_: any) => {};
  onTouch = () => {};

  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChanged(value: boolean) {
    this.checked = value;
    this.onChange(value);
    this.onTouch();
    this.checkedChange.emit(value);
  }
} 